import { post, put } from './utils';

const callCustomPostAction = async (url, params = {}) => post(url, params);
const callCustomPutAction = async (url, params = {}) => put(url, params);

export const digitalCoach = {
  callCustomPostAction,
  callCustomPutAction
};
